module.exports = __webpack_public_path__ + "static/img/DSC_1577.4c4e1ab6.jpg";